__turbopack_context__.v({
  "guide": "Scanner-module__mrQPSW__guide",
  "overlay": "Scanner-module__mrQPSW__overlay",
  "overlay_text": "Scanner-module__mrQPSW__overlay_text",
  "video": "Scanner-module__mrQPSW__video",
});
